// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__t_UbC","messages":"Chat_messages__2sdqG","dateDivider":"Chat_dateDivider__31dDF"};